import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

const state = { isFullScreen: false };

export default { state, mutations, actions, getters };
